import { Card, CardContent, CardHeader, CardTitle } from "@wa/ui";
import { ShieldCheck, ShieldAlert } from "lucide-react";
import { fmt, type AuditRow } from "./lib";

// ── Audit ───────────────────────────────────────────────────────────────────
export function AuditCard({ audit, locale, t }: { audit: AuditRow[]; locale: string; t: (k: string, v?: Record<string, string | number>) => string }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("security.audit")}</CardTitle>
        <p className="text-sm text-muted-foreground">{t("security.auditHint")}</p>
      </CardHeader>
      <CardContent>
        {audit.length === 0 ? (
          <p className="text-sm text-muted-foreground">{t("security.noAudit")}</p>
        ) : (
          <ul className="space-y-1.5">
            {audit.map((e) => {
              const ok = e.eventType.endsWith(".success") || e.eventType === "mfa.verified" || e.eventType === "password.changed";
              const failure = e.eventType.endsWith(".failure");
              const Icon = failure ? ShieldAlert : ShieldCheck;
              return (
                <li key={e.id} className="flex items-center gap-2.5 text-sm">
                  <Icon className={failure ? "size-4 text-destructive" : ok ? "size-4 text-emerald-600" : "size-4 text-muted-foreground"} />
                  <span className="flex-1">{t(`audit.${e.eventType}`)}</span>
                  <span className="text-xs text-muted-foreground">{fmt(e.createdAt, locale)}</span>
                </li>
              );
            })}
          </ul>
        )}
      </CardContent>
    </Card>
  );
}
